import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Outgoing: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fill="#0080FF"
            fillRule="evenodd"
            d="M9.625,1 C10.3397214,1 10.927078,1.55522888 10.9937056,2.26517066 L11,2.4 L11,7 L8,7 L8,10 L11,10 L11,13.6 C11,14.3277164 10.4546859,14.9257521 9.75742168,14.9935912 L9.625,15 L1.375,15 C0.660278559,15 0.072922045,14.4447711 0.00629436322,13.7348293 L0,13.6 L0,5.2 L4.125,1 L9.625,1 Z M13.4074074,6 L16,8.5 L13.4074074,11 L12.6711111,10.29 L14.0140741,9 L9,9 L9,8 L14.0140741,8 L12.6711111,6.705 L13.4074074,6 Z M9.625,2.4 L8.25,2.4 L8.25,5.2 L9.625,5.2 L9.625,2.4 Z M7.5625,2.4 L6.1875,2.4 L6.1875,5.2 L7.5625,5.2 L7.5625,2.4 Z M5.5,2.4 L4.125,2.4 L4.125,5.2 L5.5,5.2 L5.5,2.4 Z"
        />
    </SvgIcon>
);

export default Outgoing;
